import React from "react";
import { Result } from "antd";

const NotAllowed: React.FC = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        backgroundColor: "#f0f2f5",
      }}
    >
      <Result
        status="403"
        title="Access Denied"
        subTitle={
          <>
            You are not allowed to access Targeted Marketing feature. <br />
            Please contact the administrator!
          </>
        }
        style={{
          backgroundColor: "white",
          padding: 24,
          borderRadius: 8,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      />
    </div>
  );
};

export default NotAllowed;
